export default "__VITE_ASSET__DaUMo319__"